<template>
  <div class="mb-2">
    <SpinnerContainer v-show="$store.state.appConfig.isLoading"/>
    <div id="pcaPlotContainer" ref="plot"></div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
    };
  },
  methods: {
  },
  mounted() {
  },
};
</script>

<style>
.js-plotly-plot .plotly .main-svg {
  background-clip: border-box;
  margin-bottom: 2rem;
}

#pcaPlotContainer {
  height: 100vh !important;
  box-sizing: border-box !important;
}

#pcaPlotContainerMobile {
  height: 700px !important;
  box-sizing: border-box !important;
}

@media (min-width: 769px) {
  .mobile-pca-alert-hide {
    display: none !important;
  }
}
</style>
